export default "__VITE_ASSET__a2b714bc__"